import { render } from "./DashboardRedZones.vue?vue&type=template&id=409488ec&scoped=true"
import script from "./DashboardRedZones.vue?vue&type=script&lang=js"
export * from "./DashboardRedZones.vue?vue&type=script&lang=js"

import "./DashboardRedZones.vue?vue&type=style&index=0&id=409488ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409488ec"]])

export default __exports__